<template>
    <div class="ff-bold text-center p-4">
        Processing...
    </div>
</template>
<script>
import { Encrypt } from '@/core/Encrypt/Encrypt'
import Utility from '@/helper/Utility'
export default {
    name: 'OAuthCallback',
    props: {},
    components: {},
    mixins: [],
    emits: [],
    data: function () { return {} },
    computed: {},
    created: function () { },
    mounted: function () {
        // console.log(this.$route.query)
        let code = this.$route.query.code
        let state = JSON.parse(this.$route.query.state || {})
        if (state.module == "yescoin") {
            let queryParams = this.decryptQueryStringToObj(state)
            this.yesCoinHandler(code, queryParams, state.accessKey)
        } else if (state.module == "bitkub") {
            let queryParams = this.decryptQueryStringToObj(state)
            this.bitkubHandler(code, queryParams, state.accessKey)
        }
    },
    methods: {
        decryptQueryStringToObj: function (state) {
            // console.log(state)
            const encryptor = new Encrypt()
            let raw = encryptor.decryptQueryString(state.data, state.module)
            let json = JSON.parse(decodeURIComponent(raw))
            return json
        },
        //#region handler
        yesCoinHandler: function (code, data, accessKey = null) {
            let qs = {
                code, // append code
            }
            if (!Utility.isEmptyStr(accessKey)) {
                qs.accKey = accessKey
            } else {
                qs = {
                    ...qs,
                    ...data,
                }
            }
            this.$router.replace({
                path: "/yescoin",
                query: qs
            })
        },
        bitkubHandler: function (code, data, accessKey = null) {
            let qs = {
                code, // append code
            }
            if (!Utility.isEmptyStr(accessKey)) {
                qs.accKey = accessKey
            } else {
                qs = {
                    ...qs,
                    ...data,
                }
            }
            this.$router.replace({
                path: "/bitkub",
                query: qs
            })
        }
        //#endregion
    }
}
</script>
